import { render } from "./IconCut.vue?vue&type=template&id=1d89da1a"
const script = {}
script.render = render

export default script